import { RootPaths } from "../App/paths";

export const ACCOUNT_REACTIVATION_PATH = "reactivation";
export const ACCOUNT_REACTIVATION_BASE_PATH = `${RootPaths.APP_V2}/${ACCOUNT_REACTIVATION_PATH}`;

export const ACCOUNT_REACTIVATION_SUCCESS_PATH = "success";
export const ACCOUNT_REACTIVATION_SUCCESS_FULL_PATH = `${ACCOUNT_REACTIVATION_BASE_PATH}/${ACCOUNT_REACTIVATION_SUCCESS_PATH}`;
